import { render, staticRenderFns } from "./confirmAdditional.vue?vue&type=template&id=4b9b7fa6&scoped=true"
import script from "./confirmAdditional.vue?vue&type=script&lang=js"
export * from "./confirmAdditional.vue?vue&type=script&lang=js"
import style0 from "./confirmAdditional.vue?vue&type=style&index=0&id=4b9b7fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b7fa6",
  null
  
)

export default component.exports